var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "AuthCard",
    { attrs: { title: "Sign in to your account" } },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "flex items-center" },
            [
              _c("StatusIndicator", { attrs: { status: "active", pulse: "" } }),
              _c("h3", { staticClass: "ml-3 font-medium" }, [
                _vm._v("Checking your account"),
              ]),
            ],
            1
          )
        : _c("ValidationObserver", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ invalid, dirty, handleSubmit }) {
                  return [
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return handleSubmit(_vm.submit)
                          },
                        },
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "email", rules: "c_email|required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors, touched }) {
                                  return [
                                    _c("FormGroup", {
                                      attrs: {
                                        id: "username",
                                        title: "Email address",
                                        name: "email",
                                        type: "email",
                                        placeholder: "Enter your email",
                                        errors: touched ? errors : [],
                                      },
                                      model: {
                                        value: _vm.email,
                                        callback: function ($$v) {
                                          _vm.email =
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                        },
                                        expression: "email",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("UiButton", {
                          staticClass: "mt-4 mb-6 block w-full",
                          attrs: {
                            type: "submit",
                            buttonText: "Request Confirmation Email",
                            fullWidth: "",
                            disabled: invalid || !dirty,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }